export { default as VideoCameraSolidIcon } from './VideoCameraSolidIcon';
